import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    // component: () => import("../views/index/index.vue"),
    redirect:'/index'
  },
  {
    path: '/index',
    name: 'index',
    component: () => import("../views/index/index.vue"),
    // redirect:'/index'
  },
  {
    path: '/product',
    name: 'product',
    component: () => import("../views/product/product.vue"),
    meta: {
      title: "产品服务",
      foot: true
    }
    // redirect:'/product'
  },
  {
    path: '/cooperation',
    name: 'cooperation',
    component: () => import("../views/cooperation/cooperation.vue"),
    meta: {
      title: "加盟合作",
      foot: true
    }
    // redirect:'/product'
  },
  {
    path: '/exploit', 
    name: 'exploit',
    component: () => import("../views/exploit/index.vue"),
    meta: {
      title: "定制化开发",
      foot: true
    }
    // redirect:'/product'
  },
  {
    path: '/communication', 
    name: 'communication',
    component: () => import("../views/communication/index.vue"),
    meta: {
      title: "数据通",
      foot: true
    }
    // redirect:'/product'
  },
  {
    path: '/middleground',
    name:"middleground",
    component: () => import("../views/middleground/index.vue"), 
    meta:{
      title:"中台",
      foot: true
    }
  },
  {
    path: '/contract',
    name: 'contract',
    component: () => import("../views/contract/index.vue"),
    meta: {
      title: "电子合同",
      foot: true
    }
  },
  {
    path:"/about",
    name:"about",
    component:()=>import("../views/about/index.vue"),
    meta:{
      title:"关于芸众",
      foot: true
    }
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
